export const MAX_ALTERNATE_NUMBERS = 10; // Broadworks limits us to 10 alternate numbers for a team/call group
export const DEFAULT_RING_PATTERN = 'NORMAL';

export const EmergencyNumbers = [
  '00',
  '011',
  '211',
  '311',
  '0311',
  '1311',
  '411',
  '0411',
  '1411',
  '511',
  '611',
  '0611',
  '1611',
  '711',
  '811',
  '911',
  '0911',
  '1911',
  '999',
  '988',
  '112',
  '0112',
];

export const supportNumber = '4081234567';
